import { h, render } from 'preact';
import CartContext from './cart-context';
import Cart from './cart';
import globalAddToCart from './global-add-to-cart';
import '../utils/bambuser-cart-integration';
import CartErrorModal from './cart-error-modal';

export default (element, data) => {
  window.globalAddToCart = globalAddToCart;

  const renderCart = () => {
    render(
      <CartContext data={data}>
        <Cart />
        <CartErrorModal />
      </CartContext>,
      element,
    );
  };

  const init = () => {
    renderCart();
  };

  init();
};
